import * as XLSX from "xlsx";

/**
 * Export records to Excel file
 */
export const exportToExcel = (records, filename = "invoices") => {
  if (!records || records.length === 0) {
    throw new Error("No records to export");
  }

  // Prepare data for Excel
  const excelData = records.map((record) => ({
    "Invoice Number": record.invoiceNumber,
    "Company Name": record.companyName || "N/A",
    Amount: record.amount,
    "Transaction Type": record.transactionType || "N/A",
    Category: record.category || "N/A",
    "Financial Year": record.financialYear,
    "Tax Number": record.taxNumber || "N/A",
    "Payment Status": record.paymentStatus || "N/A",
    Notes: record.notes || "N/A",
    Timestamp: record.timestamp
      ? new Date(record.timestamp * 1000).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
      : "N/A",
    "Polygon Block Number": record.blockNumber || "N/A",
    "Transaction Hash": record.transactionHash || "N/A",
    "IPFS Hash": record.documentHash || "N/A",
  }));

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Set column widths
  const columnWidths = [
    { wch: 20 }, // Invoice Number
    { wch: 25 }, // Company Name
    { wch: 15 }, // Amount
    { wch: 20 }, // Transaction Type
    { wch: 20 }, // Category
    { wch: 15 }, // Financial Year
    { wch: 20 }, // Tax Number
    { wch: 15 }, // Payment Status
    { wch: 30 }, // Notes
    { wch: 22 }, // Timestamp (date & time)
    { wch: 18 }, // Polygon Block Number
    { wch: 70 }, // Transaction Hash (long!)
    { wch: 50 }, // IPFS Hash
  ];
  worksheet["!cols"] = columnWidths;

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Generate filename with timestamp
  const timestamp = new Date().toISOString().split("T")[0];
  const finalFilename = `${filename}_${timestamp}.xlsx`;

  // Save file
  XLSX.writeFile(workbook, finalFilename);

  return finalFilename;
};

/**
 * Format number as currency
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  }).format(amount);
};

/**
 * Format date to DD-MM-YYYY
 */
export const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

/**
 * Format timestamp to full date and time
 */
export const formatDateTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

/**
 * Parse DD-MM-YYYY to Date object
 */
export const parseDate = (dateString) => {
  const [day, month, year] = dateString.split("-");
  return new Date(year, month - 1, day);
};

/**
 * Get today's date in DD-MM-YYYY format
 */
export const getTodayDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  return `${day}-${month}-${year}`;
};
